import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DishesContext, IDishesContext } from '../../../../dishesState/dishesContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { dishes, IDSelectedRestaurant, setDishIDForDeletion, setDishIDForFullInfo } =
		useContext<IDishesContext>(DishesContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const articleHeadingClasses = classNames(style.article, style.heading);
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const subcategoryHeadingClasses = classNames(style.subCategory, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const isDisabledHeadingClasses = classNames(style.isDisabled, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const externalIdHeadingClasses = classNames(style.externalId, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={subcategoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="subcategoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isDisabledHeadingClasses}
					translationNameSpace="listing"
					translationKey="inStopLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="signedPriceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={externalIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="externalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{dishes.dishes.map((item, index) => (
				<Item
					data={item}
					key={item.id}
					index={index}
					IDSelectedRestaurant={IDSelectedRestaurant}
					setDishIDForDeletion={setDishIDForDeletion}
					setDishIDForFullInfo={setDishIDForFullInfo}
				/>
			))}
		</div>
	);
};

export default List;
